import Script from "next/script"
import React, { useEffect, useRef } from "react"
import { useCoralConfig } from "@octopus-energy/coral/providers"

type TrustpilotProps = {
    templateId: string
    businessUnitId: string
    height?: string
    width?: string
    theme?: "light" | "dark"
    tags?: string
    reviewLanguages?: string
    stars?: string
    disableInteraction?: boolean
}

export function Trustpilot({
    templateId,
    businessUnitId,
    height = "100%",
    width = "100%",
    theme,
    tags,
    reviewLanguages,
    stars,
    disableInteraction,
}: TrustpilotProps) {
    const { colorMode } = useCoralConfig();
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true)
        }
    }, [])

    return (
        <>
            <Script
                type="text/javascript"
                src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
                strategy="afterInteractive"
            />

            <div
                ref={ref}
                className="trustpilot-widget"
                data-locale="fr-FR"
                data-template-id={templateId}
                data-businessunit-id={businessUnitId}
                data-style-height={height}
                data-style-width={width}
                data-theme={theme ? theme : colorMode}
                data-stars={stars}
                data-tags={tags}
                data-review-languages={reviewLanguages}
                style={{
                    pointerEvents: disableInteraction ? "none" : "auto",
                }}
            >
                <a
                    href="https://fr.trustpilot.com/review/plum.fr"
                    target="_blank"
                    rel="noopener"
                >
                    Trustpilot
                </a>
            </div>
        </>
    )
}
